import React, { Component } from 'react'
import { AppBar, Dialog, DialogContent, Toolbar, Typography, } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'
import { bindActionCreators } from 'redux'
import ReduxGlobal from '../../../../store/actionreducers/globalView'
import { connect } from 'react-redux'
import { constDataDialogs } from '../../../../constants'
import UecareTextarea from "../../../../components/UecareTextarea"

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
})

class SurveyFeedbackDialog extends Component {
    closeDataDialog = () => {
        this.props.closeDataDialog({ name: constDataDialogs.name.surveyFeedbackDialog })
    }

    render() {

        const {
            classes,
            surveyFeedbackDialog,
            platformSuggestion,
        } = this.props

        if (!surveyFeedbackDialog || !surveyFeedbackDialog.props.open) return <div/>

        return (
            <Dialog
                className={classes.root}
                {...surveyFeedbackDialog.props}
                onClose={this.closeDataDialog}
                fullWidth
                maxWidth="xs"
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">會員任務回饋</Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{ root: 'p-24' }}>
                    <UecareTextarea
                        label="任務回饋"
                        icon="note"
                        name="platformSuggestion"
                        id="platformSuggestion"
                        className={classes.formControl}
                        value={platformSuggestion || ''}
                    />
                </DialogContent>

            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({ global: { dataDialogs }, mission:{ platformSuggestion } }) {
    return {
        surveyFeedbackDialog: dataDialogs[constDataDialogs.name.surveyFeedbackDialog],
        platformSuggestion,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(SurveyFeedbackDialog))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/surveyCount/SurveyFeedbackDialog.js